<template>
  <div identity="c-card-options-wrap">
    <cvt-collapse
      :accordion="true"
      :theme="mode === 'LIGHT' ? 'light' : 'dark'"
      :prepend-chevron="prependChevron"
    >
      <cvt-collapse-item
        v-if="containerItemSettings.isWrappedByCContainerItem"
        title="Container Item Options"
        :special-style="isSpecialStyle"
      >
        <c-container-item-options :mode="mode" />
      </cvt-collapse-item>
      <cvt-collapse-item
        name="build"
        :title="$t('elements.property.configurations.label')"
        :special-style="isSpecialStyle"
      >
        <div class="row mb-3">
          <!-- View Controls -->
          <div class="col-12">
            <cvt-field-label :mode="mode" label="Direction" />
            <cvt-radio-group
              orientation="horizontal"
              :theme="mode"
              :initial-value="flexDirection"
            >
              <el-tooltip
                v-for="item in direction"
                :key="item.value"
                :content="item.value"
                placement="top"
              >
                <cvt-radio-button
                  size="md"
                  :value="item.value"
                  @radioClick="() => (flexDirection = item.value)"
                >
                  <cvt-icon :icon="item.icon" style="font-size: 18px" />
                </cvt-radio-button>
              </el-tooltip>
            </cvt-radio-group>
          </div>
        </div>

        <div class="divider mt-2" />

        <div class="row mb-3">
          <!-- Card Wrap Properties -->
          <div class="col-12">
            <cvt-field-label :mode="mode" label="Wrap" />
            <cvt-radio-group
              orientation="horizontal"
              :theme="mode"
              :initial-value="flexWrap"
            >
              <el-tooltip
                v-for="item in layoutWrapOption"
                :key="item.value"
                :content="item.value"
                placement="top"
              >
                <cvt-radio-button
                  size="md"
                  :value="item.value"
                  @radioClick="() => (flexWrap = item.value)"
                >
                  <cvt-icon :icon="item.icon" style="font-size: 18px" />
                </cvt-radio-button>
              </el-tooltip>
            </cvt-radio-group>
          </div>
        </div>
        <div class="divider mt-2" />
        <div class="row mb-3">
          <!-- Justify Content Spacing Properties -->
          <div class="col-12">
            <cvt-field-label :mode="mode" label="Justify Content" />
            <cvt-radio-group
              orientation="horizontal"
              :theme="mode"
              :initial-value="justifyContent"
            >
              <el-tooltip
                v-for="item in SpacingOption.slice(0, 5)"
                :key="item.value"
                :content="`${item.value}`"
                placement="top"
              >
                <cvt-radio-button
                  size="md"
                  :value="item.value"
                  @radioClick="() => (justifyContent = item.value)"
                >
                  <cvt-icon :icon="item.icon" style="font-size: 18px" />
                </cvt-radio-button>
              </el-tooltip>
            </cvt-radio-group>

            <cvt-radio-group
              orientation="horizontal"
              :theme="mode"
              :initial-value="justifyContent"
            >
              <el-tooltip
                v-for="item in SpacingOption.slice(5, 10)"
                :key="item.value"
                :content="`${item.value}`"
                placement="top"
              >
                <cvt-radio-button
                  size="md"
                  :value="item.value"
                  @radioClick="() => (justifyContent = item.value)"
                >
                  <cvt-icon :icon="item.icon" style="font-size: 18px" />
                </cvt-radio-button>
              </el-tooltip>
            </cvt-radio-group>
          </div>
        </div>
        <div class="divider mt-2" />
        <div class="row mb-3">
          <!-- Align Items Spacing Properties -->
          <div class="col-12">
            <cvt-field-label :mode="mode" label="Align Items" />
            <cvt-radio-group
              orientation="horizontal"
              :theme="mode"
              :initial-value="alignItems"
            >
              <el-tooltip
                v-for="item in SpacingOption.slice(0, 5)"
                :key="item.value"
                :content="`${item.value}`"
                placement="top"
              >
                <cvt-radio-button
                  size="md"
                  :value="item.value"
                  @radioClick="() => (alignItems = item.value)"
                >
                  <cvt-icon :icon="item.icon" style="font-size: 18px" />
                </cvt-radio-button>
              </el-tooltip>
            </cvt-radio-group>

            <cvt-radio-group
              orientation="horizontal"
              :theme="mode"
              :initial-value="alignItems"
            >
              <el-tooltip
                v-for="item in SpacingOption.slice(5, 10)"
                :key="item.value"
                :content="`${item.value}`"
                placement="top"
              >
                <cvt-radio-button
                  size="md"
                  :value="item.value"
                  @radioClick="() => (alignItems = item.value)"
                >
                  <cvt-icon :icon="item.icon" style="font-size: 18px" />
                </cvt-radio-button>
              </el-tooltip>
            </cvt-radio-group>
          </div>
        </div>
        <div class="divider mt-2" />

        <div class="row">
          <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
            Horizontal Gap
          </div>
          <div class="col-12">
            <cvt-slider
              id="slider-default"
              :tooltips-enabled="true"
              :step-marks-enabled="true"
              class="slider"
              :min="1"
              :max="100"
              :value="horizontalGap"
              :step="1"
              @change="(value) => (horizontalGap = value)"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 mb-3 d-flex align-items-center text-capitalize">
            Vertical Gap
          </div>
          <div class="col-12">
            <cvt-slider
              id="slider-default"
              :tooltips-enabled="true"
              :step-marks-enabled="true"
              class="slider"
              :min="1"
              :max="100"
              :value="verticalGap"
              :step="1"
              @change="(value) => (verticalGap = value)"
            />
          </div>
        </div>
        <div class="divider mt-3" />

        <!-- Padding Control -->
        <div class="row mt-3">
          <div class="col-12 d-flex align-items-center justify-content-between mb-3">
            <span class="text-capitalize">Padding</span>
            <div class="d-flex align-items-center">
              <cvt-select
                mode="dropdown"
                :value="paddingUnit"
                :background-mode="mode"
                style="width: 80px"
                @input="(value) => (paddingUnit = value)"
              >
                <option
                  v-for="unit in paddingUnits"
                  :key="unit"
                  :value="unit"
                  v-text="unit"
                />
              </cvt-select>
              <el-tooltip
                :content="paddingLocked ? 'Unlock padding sides' : 'Lock padding sides'"
                placement="top"
              >
                <button
                  class="btn btn-sm ml-2 padding-lock-btn"
                  :class="{ 'locked': paddingLocked }"
                  @click="paddingLocked = !paddingLocked"
                >
                  <cvt-icon :icon="paddingLocked ? 'lock' : 'lock-open'" />
                </button>
              </el-tooltip>
            </div>
          </div>
          
          <div class="col-12">
            <div class="padding-inputs-grid">
              <!-- Top -->
              <div class="padding-input-group">
                <label class="padding-label">Top</label>
                <cvt-input
                  type="number"
                  :value="paddingTop"
                  :clearable="false"
                  @blur="onPaddingTopChange"
                />
              </div>
              
              <!-- Right -->
              <div class="padding-input-group">
                <label class="padding-label">Right</label>
                <cvt-input
                  type="number"
                  :value="paddingRight"
                  :disabled="paddingLocked"
                  :clearable="false"
                  @blur="(value) => (paddingRight = value.target.value)"
                />
              </div>
              
              <!-- Bottom -->
              <div class="padding-input-group">
                <label class="padding-label">Bottom</label>
                <cvt-input
                  type="number"
                  :value="paddingBottom"
                  :disabled="paddingLocked"
                  :clearable="false"
                  @blur="(value) => (paddingBottom = value.target.value)"
                />
              </div>
              
              <!-- Left -->
              <div class="padding-input-group">
                <label class="padding-label">Left</label>
                <cvt-input
                  type="number"
                  :value="paddingLeft"
                  :disabled="paddingLocked"
                  :clearable="false"
                  @blur="(value) => (paddingLeft = value.target.value)"
                />
              </div>
            </div>
          </div>
        </div>
      </cvt-collapse-item>

      <cvt-collapse-item
        name="manage_list"
        :title="`Manage Items`"
        :initial-active="true"
        :special-style="isSpecialStyle"
      >
        <div class="row">
          <div class="col">
            <div class="form-fields">
              <div class="row">
                <div class="col-md-12">
                  <draggable-list
                    :list="cardItems"
                    @change="updateCardFields"
                    @item-clicked="selectField"
                  >
                    <template slot="list-item-template" slot-scope="props">
                      <cvt-icon
                        id="drag-handle"
                        :icon="iconConfig.leftSidebar.layout.drag || 'copy'"
                      />
                      <span :class="{ 'blue-text': false }">
                        {{ fmtFieldName(props.item, props.index) }}
                      </span>
                    </template>
                  </draggable-list>

                  <ElementSelector
                    :mode="mode"
                    @element-selected="addCardField"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </cvt-collapse-item>

      <cvt-collapse-item
        :title="$t('elements.properties.global.style.label.container')"
        name="container_style"
      >
        <c-card-container-style-option :mode="mode" />
      </cvt-collapse-item>
    </cvt-collapse>
  </div>
</template>

<script>
import * as _ from 'lodash'
import { mapActions, mapGetters, mapState } from 'vuex'
import * as actions from '../../../../store/modules/actions'
import * as getters from '../../../../store/modules/getters'
import DraggableList from '@/js/components/editor/dragndrop/DraggableList.vue'
import { LEFT_SIDEBAR_FRESHWORKS } from '../../../../../../../storybook/components/constants'
import CCardContainerStyleOption from '../CCardContainerStyleOption.vue'
import ElementSelector from './ElementSelector.vue'
import { findDragItemByTag } from './component-details'
import CContainerItemOptions, {
  useShowContainerItem,
} from './CContainerItemOptions.vue'

export default {
  components: {
    DraggableList,
    CCardContainerStyleOption,
    ElementSelector,
    CContainerItemOptions,
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
    prependChevron: {
      type: Boolean,
      default: false,
    },
    isCardContainer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultTabs: ['build'],
      deleteFieldIdx: null,
      deleteFieldDialogOpen: false,
      borderStyles: ['none', 'solid', 'dashed', 'dotted', 'double', 'groove'],
      borderWidth: 0,
      borderRadius: 0,
      layoutWrapOption: [
        { value: 'unset', icon: 'cvt-icon-column-flex-wrap-nowrap' },
        { value: 'wrap', icon: 'cvt-icon-row-flex-wrap-wrap' },
        { value: 'nowrap', icon: 'cvt-icon-column-flex-wrap-nowrap' },
      ],
      SpacingOption: [
        { value: 'unset', icon: 'cvt-icon-column-flex-wrap-nowrap' },
        { value: 'center', icon: 'cvt-icon-column-align-items-center' },
        { value: 'start', icon: 'cvt-icon-column-align-items-flex-start' },
        { value: 'end', icon: 'cvt-icon-column-align-items-flex-end' },
        { value: 'left', icon: 'cvt-icon-column-align-items-flex-start' },
        { value: 'right', icon: 'cvt-icon-column-align-items-flex-end' },
        {
          value: 'space-around',
          icon: 'cvt-icon-column-align-content-space-around',
        },
        {
          value: 'space-between',
          icon: 'cvt-icon-column-align-content-space-between',
        },
        {
          value: 'space-evenly',
          icon: 'cvt-icon-row-justify-content-space-evenly',
        },
        { value: 'stretch', icon: 'cvt-icon-column-align-items-stretch' },
      ],
      direction: [
        { value: 'column', icon: 'cvt-icon-flex-direction-column' },
        { value: 'row', icon: 'cvt-icon-flex-direction-row' },
      ],
      selectedFieldId: null,
      selectedField: null,
      isUpdatingOrderChange: false,
      paddingLocked: true,
      paddingUnits: ['px', '%', 'em', 'rem'],
    }
  },
  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED,
      config: getters.AUTH_GET_USER_CONFIG,
      user: getters.AUTH_GET_USER,
      site: getters.SITE_GET_DATA,
      advancedMenuTabs: getters.ADVANCED_MENU_TABS,
      isGridBuilder: getters.IS_GRID_BUILDER,
      isStandalonePopupEnabled: getters.STANDALONE_POPUP_ACTIVE,
      viewMode: getters.VIEW_MODE,
    }),
    ...mapState('globalTheme', {
      iconConfig: ({ iconConfig }) => iconConfig,
    }),
    isSpecialStyle() {
      return this.OrgName === LEFT_SIDEBAR_FRESHWORKS
    },
    cardItems() {
      if (this.selected.fbNode.children?.length === 0 || !this.selected.fbNode.children) {
        return []
      }
      return this.selected.fbNode.children.map((node) => {
        return {
          component: node,
          id: node.data.props.vnodeId,
        }
      })
    },
    flexWrap: {
      get() {
        return _.get(this, `selected.${this.viewMode}.flexWrap`, 'wrap')
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/flexWrap`, value })
      }),
    },
    flexDirection: {
      get() {
        return _.get(this, `selected.${this.viewMode}.flexDirection`, 'row')
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/flexDirection`, value })
      }),
    },
    horizontalGap: {
      get() {
        return _.get(this, `selected.${this.viewMode}.horizontalGap`, 0)
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/horizontalGap`, value })
      }),
    },
    verticalGap: {
      get() {
        return _.get(this, `selected.${this.viewMode}.verticalGap`, 10)
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/verticalGap`, value })
      }),
    },
    justifyContent: {
      get() {
        return _.get(this, `selected.${this.viewMode}.justifyContent`, 'start')
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/justifyContent`, value })
      }),
    },
    alignItems: {
      get() {
        return _.get(this, `selected.${this.viewMode}.alignItems`, 'start')
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/alignItems`, value })
      }),
    },
    paddingUnit: {
      get() {
        return _.get(this, `selected.${this.viewMode}.padding.unit`, 'px')
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/padding/unit`, value })
      }),
    },
    paddingTop: {
      get() {
        return _.get(this, `selected.${this.viewMode}.padding.top`, 0)
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/padding/top`, value })
        this.updateProp({ key: `${this.viewMode}/padding/unit`, value: this.paddingUnit })
      }, 300),
    },
    paddingRight: {
      get() {
        return _.get(this, `selected.${this.viewMode}.padding.right`, 0)
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/padding/right`, value })
        this.updateProp({ key: `${this.viewMode}/padding/unit`, value: this.paddingUnit })
      }, 300),
    },
    paddingBottom: {
      get() {
        return _.get(this, `selected.${this.viewMode}.padding.bottom`, 0)
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/padding/bottom`, value })
        this.updateProp({ key: `${this.viewMode}/padding/unit`, value: this.paddingUnit })
      }, 300),
    },
    paddingLeft: {
      get() {
        return _.get(this, `selected.${this.viewMode}.padding.left`, 0)
      },
      set: _.throttle(function (value) {
        this.updateProp({ key: `${this.viewMode}/padding/left`, value })
        this.updateProp({ key: `${this.viewMode}/padding/unit`, value: this.paddingUnit })
      }, 300),
    },
    hideFlexAlignment() {
      return this.config.HIDE_FLEX_ALIGNMENT_OPTIONS?.form === true
    },
    containerItemSettings() {
      return useShowContainerItem(this.selected)
    },
  },
  methods: {
    ...mapActions({
      updateProp: actions.SELECTOR_UPDATE_PROP,
    }),
    showOption(...views) {
      return views.includes(this.viewMode)
    },
    async updateCardFields(cardItems) {
      await this.selected.updateChildrenElements(
        cardItems.map((x) => x.component),
      )
    },
    selectField({ payload, index }) {
      // if (this.selectedFieldId === payload.id) {
      //   this.selectedFieldId = null
      //   this.selected.children()[index].deselectItem()
      //   this.selectedField = null
      //   return
      // }
      // this.selectedFieldId = payload.id
      // this.selected.children()[index].selectItem()
      // this.getSelectedField()
    },
    getSelectedField() {
      const result = _.find(this.cardItems, {
        id: this.selectedFieldId,
      })
      this.selectedField = result?.component
    },
    fmtFieldName(item, index) {
      if (
        item.component.children?.length === 0 ||
        item.component.children?.length > 1
      ) {
        return `Card ${index + 1}`
      }
      const dragItem = findDragItemByTag(item.component.children[0].tag)
      if (dragItem) {
        return dragItem.label
      }
      return `Card ${index + 1}`
    },
    addCardField: async function (element) {
      await this.selected.addItem(element)
    },
    getComponent() {

    },
    onPaddingTopChange(value) {
      const paddingValue = parseInt(value.target.value)
      this.paddingTop = paddingValue
      if (this.paddingLocked) {
        this.paddingRight = paddingValue
        this.paddingBottom = paddingValue
        this.paddingLeft = paddingValue
      }
    },
  },
}
</script>

<style lang="scss">
.padding-inputs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.padding-input-group {
  display: flex;
  flex-direction: column;
  
  .padding-label {
    font-size: 12px;
    margin-bottom: 4px;
    color: #666;
    text-transform: capitalize;
  }
}

.padding-lock-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  
  &.locked {
    background: rgba(0, 123, 255, 0.1);
    border-color: #007bff;
    color: #007bff;
  }
}
</style>
